let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9D49i")).then(() => parcelRequire('3oVAl'));